/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import config from "../config/sidebarItems.config.json";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_BANDS } from "../graphql";
import { getShopUrl, isShopEnabled } from "../../../common/shop";

const SERVICE_NAME = "AppNavigatorService.SidebarItemsService";
const log: any = LoggerModule.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const is = require("is_js");

interface ISidebarProps {
  whoami: string;
}

export interface ISidebarMethods extends IPluginMethodMap {
  getSidebarItems(args: ISidebarProps): Promise<any>;
}

export class SidebarItemService implements IAgentPlugin {
  readonly methods: ISidebarMethods;

  constructor() {
    this.methods = {
      getSidebarItems: this.getSidebarItems.bind(this),
    };
  }

  async getSidebarItems(args: ISidebarProps) {
    const { whoami } = args;

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("ars", args);

    const storageSrv = StorageModule.getInstance();
    const band = storageSrv?.get("theme", "local");

    const full_items = config.sidebarItems;
    const res1 = await client.query({
      query: GET_BANDS,
      variables: {
        filter: {
          bandName: band?.bandName,
        },
      },
      fetchPolicy: "network-only",
    });

    let dynamicPages: any[] = [];
    if (res1?.data?.getBand) {
      console.log(res1?.data?.getBand?.sidebar);
      dynamicPages = res1?.data?.getBand?.sidebar
        .filter((item) => item.enabled)
        .map((item) => item.name);
    }

    const items = full_items.map((item) => {
      if (item.id === "RADashboard" && Array.isArray(item.children)) {
        const filteredChildren = item.children.filter((child) =>
          dynamicPages.includes(child.title)
        );
        return {
          ...item,
          children: filteredChildren,
        };
      }
      return item;
    });

    const _items: any = [];
    for (let i = 0; i < items?.length; ++i) {
      const _item: any = items[i];
      if (_item?.id === "ShopMasquerader") {
        if (!isShopEnabled() || this.isBlackListFound(whoami, _item?.id)) {
          continue;
        }
        _items.push({
          ..._item,
          link: getShopUrl(),
          external: true,
          target: "_blank",
        });
        continue;
      }
      if (_item?.id) {
        if (!this.isBlackListFound(whoami, _item?.id)) {
          _items.push(_item);
        }
      } else if (_item?.children) {
        const _children = [];
        _item?.children.forEach((_childItem: any) => {
          if (_childItem?.id) {
            if (!this.isBlackListFound(whoami, _childItem?.id)) {
              _children.push(_childItem);
            }
          }
        });
        const _temp = { ..._item };
        _temp.children = _children;
        _items.push(_temp);
      } else {
        _items.push(_item);
      }
    }
    if (band?.isMultiplePurchase) {
      const costumesSection = _items.find(
        (section: any) => section.title === "Costumes"
      );
      if (costumesSection) {
        const ordersItem = costumesSection.children.find(
          (child: any) => child.title === "Orders"
        );
        if (ordersItem) {
          ordersItem.link = "/purchasedCostumeList";
          ordersItem.id = "PurchasedCostumeList";
        }
      }
    }
    console.log(_items);
    return { sidebarItems: _items };
  }

  private isBlackListFound(whoami: string, id: string) {
    let _found = false;
    const blacklist = config["blacklistItems"][whoami];
    if (blacklist) {
      if (blacklist.find((bl) => bl == id)) {
        _found = true;
      }
    }
    return _found;
  }
}
// {
//   "type": "non-collapsable",
//   "title": "Discount",
//   "link": "/create-discount",
//   "id": "CreateDiscount",
//   "icon": "https://img.icons8.com/dotty/ffffff/80/sale-price-tag.png"
// },
// {
//   "type": "collapsable",
//   "eventKey": "distribution/",
//   "title": "Distribution",
//   "id": "Distribution",
//   "icon": "https://i.ibb.co/Hrcy5SM/fast-delivery.png",
//   "children": [
//     {
//       "title": "Shelf",
//       "link": "/shelf",
//       "id": "ShelfList",
//       "icon": "https://i.ibb.co/j87JZpL/store.png"
//     },
//     {
//       "title": "Create Schedules",
//       "link": "/schedule-list",
//       "id": "ScheduleList",
//       "icon": "https://i.ibb.co/gSG18tJ/calendar.png"
//     },
//     {
//       "title": "View schedules",
//       "link": "/schedule-view",
//       "id": "ScheduleTable",
//       "icon": "https://i.ibb.co/g76Svfw/search-1.png"
//     }
//   ]
// },
// {
//   "type": "non-collapsable",
//   "title": "Route Map",
//   "link": "/band-route-map",
//   "id": "BandRouteMap",
//   "icon": "https://img.icons8.com/ios-filled/100/EBEBEB/map.png"
// },

// {
//   "title": "Delivered Report",
//   "link": "/delivered-report",
//   "id": "DeliveredReport",
//   "icon": "https://i.ibb.co/9qrqkvp/delivered-removebg-preview.png"
// }
// {
//       "type": "non-collapsable",
//       "title": "Print Labels",
//       "link": "/print-labels",
//       "id": "PrintLabels",
//       "icon": "https://img.icons8.com/ios-filled/100/EBEBEB/print.png"
//     },
// {
//   "title": "Coupon Report",
//   "link": "/coupon-report",
//   "id": "CouponReport",
//   "icon": "https://img.icons8.com/dotty/ffffff/80/sale-price-tag.png"
// },

// {
//   "title": "Assign Open Reg.",
//   "link": "/manageOpenRegistration",
//   "id": "ManageOpenRegistration",
//   "icon": "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/verified_grey.png"
// }
